export default {"src":"/_next/static/media/worldclass-workplace-2023-2024.f4835b3c.svg","height":188,"width":140,"blurWidth":0,"blurHeight":0};